import { defineMessages, type MessageDescriptor } from 'react-intl';

export const messages: Record<string, MessageDescriptor> = defineMessages({
	undo: {
		id: 'editor-plugin-ai.SessionUI.screens.PostStreamReview.undo',
		defaultMessage: 'Undo',
		description: 'Label for the undo button in the post-stream review toolbar.',
	},
	redo: {
		id: 'editor-plugin-ai.SessionUI.screens.PostStreamReview.redo',
		defaultMessage: 'Redo',
		description: 'Label for the redo button in the post-stream review toolbar.',
	},
	viewChanges: {
		id: 'editor-plugin-ai.SessionUI.screens.PostStreamReview.viewChanges',
		defaultMessage: 'View changes',
		description: 'Label for the view changes button in the post-stream review toolbar.',
	},
	hideChanges: {
		id: 'editor-plugin-ai.SessionUI.screens.PostStreamReview.hideChanges',
		defaultMessage: 'Hide changes',
		description:
			'Label for the toggle button when changes are currently shown; clicking it hides the highlighted changes in the post-stream review toolbar.',
	},
	segmentPosition: {
		id: 'editor-plugin-ai.SessionUI.screens.PostStreamReview.segmentPosition',
		defaultMessage: '{current} / {total}',
		description:
			'Shows the current change position out of the total number of changes (e.g. "2 / 2") in the post-stream review step-through navigation.',
	},
	previousChange: {
		id: 'editor-plugin-ai.SessionUI.screens.PostStreamReview.previousChange',
		defaultMessage: 'Go to previous',
		description:
			'Label (also shown as the hover tooltip) for the previous-segment navigation button in the post-stream review toolbar.',
	},
	nextChange: {
		id: 'editor-plugin-ai.SessionUI.screens.PostStreamReview.nextChange',
		defaultMessage: 'Go to next',
		description:
			'Label (also shown as the hover tooltip) for the next-segment navigation button in the post-stream review toolbar.',
	},
	stepThrough: {
		id: 'editor-plugin-ai.SessionUI.screens.PostStreamReview.stepThrough',
		defaultMessage: 'Step through all changes',
		description:
			'Label (also shown as the hover tooltip) for the button that reveals segment navigation controls in the post-stream review toolbar.',
	},
});
